import PropTypes, { bool, func } from 'prop-types'
import React, { useEffect, useState } from 'react'
import { connect } from 'react-redux'
import { isEqual } from 'lodash'

import { loadCart } from '../store/actions'
import { track } from '../utils/tracking'
import { trackCartProductClick } from '../utils/googleAnalytics'
import Theme from '../components/Theme'
import compose from '../utils/compose'
import translate from '../utils/translate'
import usePrevious from '../utils/hooks/usePrevious'
import withI18n from '../components/withI18n'

function Cart({ t, displayWishlistError, cart }) {
  const [invalidProducts, setInvalidProducts] = useState(
    cart.productLineItems.filter((item) => item.productId === null),
  )
  const previousCart = usePrevious(cart)

  const title = t('views.storefrontView.basketPageSection.title')
  const metaTags = [<meta key="robots" name="robots" content="noindex, follow" />]

  useEffect(() => {
    setInvalidProducts(cart.productLineItems.filter((item) => item.productId === null))
  }, [cart])

  useEffect(() => {
    if (!isEqual(previousCart, cart)) {
      track('cart', { cart })
    }
  }, [previousCart, cart])

  return (
    <Theme withLayout currentView="cart" title={title} titleShouldIncludeShop metaTags={metaTags}>
      {(renderView, props) =>
        renderView('Cart', {
          ...props,
          cart: cart,
          trackProductClick: trackCartProductClick,
          displayWishlistError,
          invalidProducts,
        })
      }
    </Theme>
  )
}

Cart.propTypes = {
  t: func.isRequired,
  cart: PropTypes.object.isRequired,
  displayWishlistError: bool,
}

Cart.storeUpdate = (props, state) => (props.location.action === 'PUSH' || !state.get('cart') ? [loadCart()] : [])

Cart.contentCreationDisabled = () => true

export default compose(
  withI18n('shop'),
  translate(),
  connect((state) => ({
    cart: state.get('cart').toJS(),
    displayWishlistError: Boolean(state.getIn(['location', 'query', 'displayWishlistError'])),
  })),
)(Cart)
